import * as React from 'react';

import { Shape2Tone } from '../../../components/Shape2/Shape2';
import { Bem } from '../../../service/Bem/Bem';
import { CanvasPcodeVideoFrameParams } from '../../../service/Pcode/PcodeCanvasVideo';
import { ValidationErrorData } from '../../../typings/common';
import { Page } from '../../common/typings';
import { CreativeOptionsData } from '../../CreativeOptions/typings';
import { PcodeVideoCanvasPreview } from '../../PcodeVideoCanvasPreview/PcodeVideoCanvasPreview';
import { AddCreativePage } from '../AddCreativePage';

import './AddVideoCreative.css';
import { LongUploadPopup } from './LongUploadPopup/LongUploadPopup';

export interface AddVideoCreativeProps {
    videoPreviewData?: Partial<CanvasPcodeVideoFrameParams>;

    submitEnabled?: boolean;
    isLoading: boolean;
    isSaving: boolean;
    isPreviewLoading?: boolean;

    creativeOptions?: CreativeOptionsData;
    onSaveName: (name: string) => void;
    onOptionChange: (groupName: string, name: string, value: string) => void;
    onGroupVisibleChange: (groupName: string) => void;
    onReturnClick: (page?: Page) => void;

    returnPage?: Page;
    initVideoData: () => void;
    onSave: () => void;
    onCancel: () => void;
    onAdEndCallback: () => void;
    error?: ValidationErrorData;

    isAudio?: boolean;
    isVideoAddition?: boolean;

    longUploadPopupVisible?: boolean;
    closeLongUploadPopup: () => void;

    shouldCreate?: boolean;
}

const BLOCK = 'add-video-creative';

export class AddVideoCreative extends React.PureComponent<AddVideoCreativeProps> {
    private previewVideoRef: React.RefObject<PcodeVideoCanvasPreview> = React.createRef();

    componentDidMount(): void {
        this.props.initVideoData();
    }

    componentDidUpdate(prevProps: Readonly<AddVideoCreativeProps>): void {
        const { isPreviewLoading } = this.props;
        if (prevProps.isPreviewLoading !== isPreviewLoading && this.previewVideoRef.current) {
            this.previewVideoRef.current.onExternalToggleLoadingStatus({
                isLoading: Boolean(isPreviewLoading)
            });
        }

        if (this.props.shouldCreate) {
            this.props.onSave();
        }
    }

    render(): React.ReactNode {
        const { longUploadPopupVisible, closeLongUploadPopup, isVideoAddition, ...addCreativeProps } = this.props;

        return (
            <>
                <AddCreativePage
                    {...addCreativeProps}
                    isDocCenterTooltip={true}
                    preview={this.renderPreview()}
                    titleCls={Bem.cls(BLOCK, 'preview-title')}
                    optionsCls={Bem.cls(BLOCK, 'options')}
                    iconsTone={Shape2Tone.white}
                />
                <LongUploadPopup
                    isVisible={Boolean(longUploadPopupVisible)}
                    onClose={closeLongUploadPopup}
                    isVideoAddition={isVideoAddition}
                />
            </>
        );
    }

    private renderPreview = (): React.ReactNode => {
        const { videoPreviewData, isAudio, onAdEndCallback } = this.props;

        return (
            <div className={Bem.cls(BLOCK, 'preview-container')}>
                <PcodeVideoCanvasPreview
                    onAdEndCallback={onAdEndCallback}
                    videoPreviewData={videoPreviewData}
                    isAudio={Boolean(isAudio)}
                    ref={this.previewVideoRef}
                />
            </div>
        );
    };
}
